import dynamic from "next/dynamic";

// `react-hook-speech-to-text` (pulled in by VoiceInputButton -> useVoiceInput)
// touches `window.AudioContext`/`SpeechRecognition`/`navigator` at module
// eval, which crashes Next's prerender for any page that imports this barrel.
// Defer the entire subtree to the client. Re-exporting the hook/helpers here
// would re-introduce the SSR import — keep them folder-local instead.
export const VoiceInputButton = dynamic(() => import("./VoiceInputButton").then(m => m.VoiceInputButton), {
  ssr: false,
});

export type { VoiceInputSize, VoiceInputVariant } from "./VoiceInputButton";
